import { render, staticRenderFns } from "./CalculatorFruit.vue?vue&type=template&id=708b6162&scoped=true&"
import script from "./CalculatorFruit.vue?vue&type=script&lang=js&"
export * from "./CalculatorFruit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b6162",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
